import { useEffect, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

import Box from '@mui/material/Box';

import { ItemType } from 'src/components/common/field/TypeCustom';
import { FieldTableType } from 'src/components/common/table/TypeCustom';
import { getAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import { getField } from 'src/common/helper';
import { useNotify } from 'src/context/ContextNotify';

import Record from 'src/components/common/table/Record';
import DialogDetail from 'src/components/quotations/Dialogdetail';
import DialogFormPayment from 'src/components/quotations//Payment/DialogForm';
import DialogForm from 'src/components/quotations/DialogForm';


export type QuotationType = {
};

const Quotation: React.FC<QuotationType> = (props) => {
  const notifyContext = useNotify();
  const [searchParams] = useSearchParams();
  const patientid = searchParams.get('id')
  const [loading, setLoading] = useState(false);
  const [quotes, setQuotes] = useState<any[]>([]);
  const [showDialogDetail, setShowDialogDetail] = useState(false);
  const [showDialogForm, setShowDialogForm] = useState(false);
  const [id, setId] = useState<number>(0);
  const [showDialogFormPayment, setShowDialogFormPayment] = useState(false);
  const [infoPayment, setInfoPayment] = useState<{
    paymentid: number,
    patientid: number,
    caseid: number
  }>();

  const fields: FieldTableType[] = [
    {
      label: '番号順',
      field: 'index',
      align: 'left',
      width: '20%'
    },
    {
      label: 'タイトル',
      field: 'title',
      align: 'left',
      width: '20%'
    },
    {
      label: '発行日',
      field: 'quotedate',
      align: 'left',
      width: '20%'
    },
    {
      label: '総額',
      field: 'amount',
      align: 'left',
      width: '20%',
      isPrice: true
    },
    {
      label: 'ステータス',
      field: 'status',
      align: 'left',
      width: '20%',
      isStatus: true
    }
  ];

  const statuses: ItemType[] = [
    {
      id: '1',
      name: '未支払い',
      accessories: '#FC6E51'
    },
    {
      id: '2',
      name: '支払済み',
      accessories: '#37BC9B'
    },
    {
      id: '3',
      name: '予約済み',
      accessories: '#F6BB42'
    }
  ];

  const handleCloseDialogDetail = (isRefreshList?: boolean) => {
    setShowDialogDetail(false);
  };

  const handleCloseDialogFormPayment = (isRefreshList?: boolean) => {
    setShowDialogFormPayment(false);
  };

  const handleCloseDialogForm = (isRefreshList?: boolean) => {
    setShowDialogForm(false);

    // if (isRefreshList === true) {

    // }
  };

  const handleClickPayment = (info: any) => {
    setInfoPayment(info);
    handleCloseDialogDetail();
    setShowDialogFormPayment(true);
  };

  const handleClickEditFromDetail = (info: any) => {
    setId(Number(info.quoteid ? info.quoteid : 0));

    setShowDialogForm(true);
    handleCloseDialogDetail(true);
  }

  const handleClickRow = (data: any | undefined) => {
    const id = getField(data, 'id', 0);

    if (id) {
      setId(Number(id));
    }

    setShowDialogDetail(true);
  };

  const getQuote = () => {
    try {
      const token = getToken();
      setLoading(true);
      getAPI(`/patient/view?patientid=${patientid}&token=${token}`)
        .then((res) => {
          if (res.code === 200) {
            setQuotes(res.data.quotes);
          } else {
            notifyContext.setNotifyMessage({
              show: true,
              message: res.msg,
              type: 'error'
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.error('Failed to fetch data:', error);
      return;
    }
  };

  useEffect(() => {
    getQuote();
    // eslint-disable-next-line
  }, []);

  return (
    <Box>
      <Record isLoading={loading} items={quotes} fields={fields} statuses={statuses} onClickRow={handleClickRow} />
      <DialogDetail
        open={showDialogDetail}
        patientId={Number(patientid)}
        id={id}
        onClose={handleCloseDialogDetail}
        openFormPayment={handleClickPayment}
        openFormQuote={handleClickEditFromDetail}
      />

      <DialogForm
        open={showDialogForm}
        patientId={Number(patientid)}
        quoteId={id}
        onClose={handleCloseDialogForm}
      />

      <DialogFormPayment
        open={showDialogFormPayment}
        infoPayment={infoPayment}
        onClose={handleCloseDialogFormPayment}
      />
    </Box>
  );
};

export default Quotation;
